import { makeStyles } from '@material-ui/core/styles';
import PageviewIcon from '@material-ui/icons/Pageview';
import {
    ContainerFieldsList,
    CustomBreadcrumbs,
    CustomSelectArrayInput,
} from 'candy-commons-components';
import React, { useState } from 'react';
import {
    BooleanInput,
    Create,
    FormDataConsumer,
    SimpleForm,
    TextInput,
    required,
    useTranslate,
} from 'react-admin';
import countries from '../../data/countries.json';
import { useSelector } from 'react-redux';

import { getApplianceTypes } from '../../selectors/cmsConfig';
const GetFeedBackTargetCreate = (props) => {
    const translation = useTranslate();
    const [allApplianceFlag, setAllApplianceFlag] = useState(false);
    const [noApplianceFlag, setNoApplianceFlag] = useState(false);
    const applianceTypes = useSelector(getApplianceTypes);

    const breadcrumbsData = [
        {
            text: translation('resources.getfeedback-target.name'),
            url: 'getfeedback-target',
            icon: <PageviewIcon />,
        },
        {
            text: translation('resources.getfeedback-target.create.name'),
            url: '',
        },
    ];
    const handleAllAppliance = (e) => setAllApplianceFlag(e.target.checked);
    return (
        <>
            <CustomBreadcrumbs data={breadcrumbsData} />
            <Create {...props}>
                <SimpleForm>
                    <ContainerFieldsList>
                        <TextInput
                            label="Event name"
                            source="eventName"
                            validate={required()}
                        />
                        <BooleanInput
                            initialValue={false}
                            source="isActive"
                            label="Active"
                        />
                    </ContainerFieldsList>
                    <ContainerFieldsList>
                        <FormDataConsumer>
                            {() => (
                                <>
                                    {!allApplianceFlag && (
                                        <CustomSelectArrayInput
                                            label="Appliance types"
                                            source="applianceType"
                                            choices={applianceTypes}
                                            disabled={allApplianceFlag}
                                        />
                                    )}
                                    <BooleanInput
                                        label="All appliance"
                                        initialValue={false}
                                        source="isAllAppliance"
                                        disabled={noApplianceFlag}
                                        onClick={handleAllAppliance}
                                    />
                                </>
                            )}
                        </FormDataConsumer>
                    </ContainerFieldsList>
                    <ContainerFieldsList>
                        <BooleanInput
                            initialValue={false}
                            label="No enrolled appliance"
                            source="isNoAppliance"
                        />
                    </ContainerFieldsList>
                    <ContainerFieldsList>
                        <CustomSelectArrayInput
                            label="Countries"
                            source="countries"
                            choices={countries}
                            validate={required()}
                        />
                    </ContainerFieldsList>
                </SimpleForm>
            </Create>
        </>
    );
};
export default GetFeedBackTargetCreate;
